import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";
import {
  Col,
  Icon,
  Layout,
  Modal,
  Row,
  Button,
  Divider,
  Select,
  Input,
  DatePicker,
  TreeSelect,
} from "antd";
import hexToRgba from "hex-to-rgba";

import classes from "./DocumentManagementDashboard.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDocumentDashboardMissingGeneralRequest,
  getDocumentDashboardInventoryRequest,
  getDocumentDashboardVisibilityTypeRequest,
  getDocumentDashboardBySiteRequest,
  getDocumentDashboardPrimaryCategoryRequest,
  getDocumentDashboardExpireRequest,
  getDocumentDashboardMissingRequest,
  getDocumentDashboardMissingPerSiteRequest,
  getSitesRequest,
  getEtmfDocumentSchemaRequest,
  getEtmfDocumentSchemaFilterRequest,
} from "../../api/requests";

import MissingDocumentsPerSite from "./MissingDocumentsPerSite";
import RequiredStatusPerSite from "./RequiredStatusPerSite";
import RequiredStatusGeneral from "./RequiredStatusGeneral";

import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import { getDimensionWidth } from "../../reducers/dimensions/selectors";
import { Bar, HorizontalBar } from "react-chartjs-2";

import colors from "./colors";
import moment from "moment-timezone";
import { documentTypes } from "../../components/DocumentForm/DocumentForm";
import forEach from "lodash/forEach";
import cloneDeep from "lodash/cloneDeep";
import {
  getDocumentGeneralPrivateReadPermission,
  getDocumentGeneralReadPermission,
  getDocumentPerSiteReadPermission,
  getDocumentPerSitePrivateReadPermission,
  getDocumentPharmacyBinderPermission,
  getDocumentPublicReadPermission,
  getDocumentStudyRegulatoryBinderPermission,
  getDocumentTrainingReadPermission,
  getDocumentValidationReadPermission,
} from "../../reducers/user/selectors";

import { withParams } from "../../utils/url";
const routes = require("../../routes.json");

const { TreeNode } = TreeSelect;
const { Option } = Select;
const { Content } = Layout;

const chartOptions = {
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        ticks: { beginAtZero: true, stepSize: 10 },
        gridLines: { color: "#eee" },
      },
    ],
    xAxes: [
      {
        ticks: { min: 0, stepSize: 10 },
        gridLines: { color: "#eee" },
      },
    ],
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem, ...data) {
        return `${data[0].datasets[tooltipItem.datasetIndex].label}: ${
          tooltipItem.value
        }`.replace(/ \(.*\)/, "");
      },
    },
  },
};

class LegendContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  render() {
    return (
      <div>
        <h5
          className={classes.toggleHeadline}
          onClick={() => {
            this.setState({
              show: !this.state.show,
            });
          }}
        >
          <Icon
            type="arrow-up"
            className={classes.collapseIcon}
            style={{
              fontSize: "16px",
              transform: `rotate(${this.state.show ? "0" : "180deg"})`,
            }}
          />{" "}
          &nbsp; <span className={classes.toggleText}>{this.props.i18n.t("Show legend")}</span>
        </h5>

        {this.state.show && (
          <div>
            {map(
              this.props.legendData,
              ({ color_code, color, legend, field_name }, i) => (
                <div key={i} className={classes.legendWrapper}>
                  <div
                    className={classes.legendBox}
                    style={{
                      ...(color_code
                        ? {
                            backgroundColor: hexToRgba(color_code, "0.5"),
                            borderColor: hexToRgba(color_code, "1"),
                            borderWidth: 1,
                          }
                        : colors[color]),
                    }}
                  />
                  <b>{field_name}</b>: {legend}
                </div>
              )
            )}
          </div>
        )}
      </div>
    );
  }
}

class DocumentManagementDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      missingGeneral: [],
      inventory: [],
      visibilityType: [],
      documentsBySite: [],
      primaryCategory: [],
      documentsExpire: [],
      missing: [],
      missingPerSite: [],
      missingDocumentsPerSiteShow: false,
      requiredStatusPerSiteShow: false,
      requiredStatusGeneralShow: false,
      etmfSchemaFilter: {},
      etmfSchema: {},
      etmfSchemaLimits: {},
      sites: [],
      filtersBy: [],
      filtersValue: [],
    };
  }

  async componentDidMount() {
    this.getData();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });

      this.getETMFSchema();
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  }

  getETMFSchema = async () => {
    try {
      const { data: etmfSchema } = await getEtmfDocumentSchemaRequest();
      const {
        data: etmfSchemaFilter,
      } = await getEtmfDocumentSchemaFilterRequest(null, {
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });
      const etmfSchemaLimits = {};

      forEach(get(etmfSchema, "schema"), (category) => {
        forEach(category.sub_categories, (subCategory) => {
          forEach(subCategory.content_types, (contentTypes) => {
            if (
              contentTypes.limit_visibility_types &&
              contentTypes.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                contentTypes.limit_visibility_types;
            } else if (
              subCategory.limit_visibility_types &&
              subCategory.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                subCategory.limit_visibility_types;
            } else if (
              category.limit_visibility_types &&
              category.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                category.limit_visibility_types;
            }
          });
        });
      });

      this.setState({ etmfSchema, etmfSchemaLimits, etmfSchemaFilter });
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  };

  getData = async () => {
    this.setState({ isLoading: true });

    const filters = {
      filter_by: this.state.filtersBy,
      filter_value: this.state.filtersValue,
    };
    try {
      const [
        missingGeneral,
        inventory,
        documentsBySite,
        visibilityType,
        primaryCategory,
        documentsExpire,
        missing,
        missingPerSite,
      ] = await Promise.all([
        getDocumentDashboardMissingGeneralRequest(filters),
        getDocumentDashboardInventoryRequest(filters),
        getDocumentDashboardBySiteRequest(filters),
        getDocumentDashboardVisibilityTypeRequest(filters),
        getDocumentDashboardPrimaryCategoryRequest(filters),
        getDocumentDashboardExpireRequest(filters),
        getDocumentDashboardMissingRequest(filters),
        getDocumentDashboardMissingPerSiteRequest(filters),
      ]);
      this.setState({
        missingGeneral: missingGeneral.data,
        inventory: inventory.data,
        documentsBySite: documentsBySite.data,
        visibilityType: visibilityType.data,
        primaryCategory: primaryCategory.data,
        documentsExpire: documentsExpire.data,
        missing: missing.data,
        missingPerSite: missingPerSite.data,
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({ isLoading: false });
  };

  chartData = (chartName) => {
    return map(get(this.state, chartName, []), (item) => ({
      label: `${item.field_name} (${item.value})`,
      data: [item.value],
      ...(item.color_code
        ? {
            backgroundColor: hexToRgba(item.color_code, "0.5"),
            borderColor: hexToRgba(item.color_code, "1"),
            borderWidth: 1,
          }
        : colors[item.color]),
    }));
  };

  chartLabels = () => {
    // return map(this.state.missingGeneral, (item) => item.field_name);
    return [" "];
  };

  renderFilterItem = ({ index = this.state.filtersBy.length, viewType }) => {
    const { filtersBy, filtersValue, sites, etmfSchemaFilter } = this.state;

    return (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Filter")} by
            </b>
            <Select
              onChange={this.handleFilterChange(index)}
              value={filtersBy[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              <Option
                value="category"
                disabled={filtersBy.includes("category")}
              >
                {this.props.i18n.t("Visibility")}
              </Option>
              <Option
                value="primary_category_code"
                disabled={filtersBy.includes("primary_category_code")}
              >
                {this.props.i18n.t("Primary category")}
              </Option>
              <Option
                value="sub_category_code"
                disabled={filtersBy.includes("sub_category_code")}
              >
                {this.props.i18n.t("Sub category")}
              </Option>
              {viewType !== "folderView" && (
                <Option
                  value="content_type_code"
                  disabled={filtersBy.includes("content_type_code")}
                >
                  {this.props.i18n.t("Content type")}
                </Option>
              )}
              <Option value="site" disabled={filtersBy.includes("site")}>
                {this.props.i18n.t("Site")}
              </Option>
            </Select>
          </label>
        </div>

        {filtersBy[index] === "id__in" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("ID")}
            </b>

            <Input value={filtersValue[index]} disabled />
          </label>
        )}

        {filtersBy[index] === "category" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Visibility")}
            </b>
            <Select
              mode="multiple"
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              <Option
                value="public"
                disabled={!this.props.documentPublicReadPermission}
              >
                {this.props.i18n.t("Public")}
              </Option>
              <Option
                value="general"
                disabled={!this.props.documentGeneralReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Central Shared")}
              </Option>
              <Option
                value="general_private"
                disabled={!this.props.documentGeneralPrivateReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Central Private")}
              </Option>
              <Option
                value="per_site"
                disabled={!this.props.documentPerSiteReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Site Specific")}
              </Option>
              <Option
                value="per_site_private"
                disabled={!this.props.documentPerSitePrivateReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Site Specific Private")}
              </Option>
              <Option
                value="training"
                disabled={!this.props.documentTrainingReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Training")}
              </Option>
              <Option
                value="study_regulatory_binder"
                disabled={!this.props.documentStudyRegulatoryBinderPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Study Regulatory Binder")}
              </Option>
              <Option
                value="pharmacy_binder"
                disabled={!this.props.documentPharmacyBinderPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Pharmacy Binder")}
              </Option>
              <Option
                value="validation"
                disabled={!this.props.documentValidationReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsDashboard:Validation")}
              </Option>
            </Select>
          </label>
        )}

        {filtersBy[index] === "type" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsDashboard:Document type")}
            </b>
            <Select
              mode="multiple"
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {Object.keys(documentTypes).map((key) => (
                <Option value={key} key={key}>
                  {documentTypes[key]}
                </Option>
              ))}
            </Select>
          </label>
        )}

        {filtersBy[index] === "primary_category_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsDashboard:Primary category")}
            </b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {get(etmfSchemaFilter, "schema", []).map(({ name, code }) => (
                <Option key={code} value={code}>
                  {name}
                </Option>
              ))}
            </Select>
          </label>
        )}

        {filtersBy[index] === "sub_category_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsDashboard:Sub category")}
            </b>
            <TreeSelect
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              placeholder={this.props.i18n.t("NamespaceDocumentsDashboard:Select sub category")}
              style={{ width: "100%" }}
            >
              {get(etmfSchemaFilter, "schema", []).map(
                ({ code, name, sub_categories }) => (
                  <TreeNode
                    key={code}
                    title={<b style={{ color: "#777" }}>{name}</b>}
                    value={code}
                    selectable={false}
                  >
                    {sub_categories &&
                      sub_categories.length > 0 &&
                      sub_categories.map(({ name, code }) => (
                        <TreeNode key={code} title={name} value={code} />
                      ))}
                  </TreeNode>
                )
              )}
            </TreeSelect>
          </label>
        )}

        {filtersBy[index] === "content_type_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsDashboard:Content type")}
            </b>
            <TreeSelect
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              placeholder={this.props.i18n.t("NamespaceDocumentsDashboard:Select content type")}
              style={{ width: "100%" }}
              disabled={
                viewType === "folderView" &&
                filtersBy[index] === "content_type_code"
              }
            >
              {get(etmfSchemaFilter, "schema", []).map(
                ({ code, name, sub_categories }) => (
                  <TreeNode
                    key={code}
                    title={<b style={{ color: "#777" }}>{name}</b>}
                    value={code}
                    selectable={false}
                  >
                    {sub_categories &&
                      sub_categories.length > 0 &&
                      sub_categories.map(({ name, code, content_types }) => (
                        <TreeNode
                          key={code}
                          title={<b style={{ color: "#777" }}>{name}</b>}
                          value={code}
                          selectable={false}
                        >
                          {content_types &&
                            content_types.length > 0 &&
                            content_types.map(({ name, code }) => (
                              <TreeNode key={code} title={name} value={code} />
                            ))}
                        </TreeNode>
                      ))}
                  </TreeNode>
                )
              )}
            </TreeSelect>
          </label>
        )}

        {filtersBy[index] === "site" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Site")}
            </b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
              showSearch
              optionFilterProp="children"
              filterOption
            >
              {sites
                .sort(
                  (a, b) =>
                    +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                )
                .map((site) => (
                  <Option key={site.id} value={site.id}>
                    {site.code} - {site.name}
                  </Option>
                ))}
            </Select>
          </label>
        )}
        {filtersValue[index] && (
          <span
            className={classes.clearButton}
            onClick={this.clearFilter(index)}
          >
            {this.props.i18n.t("Remove")}
          </span>
        )}
      </div>
    );
  };

  handleFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = (index) => (value) => {
    this.setState(
      (state) => {
        const filtersValue = cloneDeep(state.filtersValue);
        filtersValue[index] = value;
        return { filtersValue, currentPage: 1 };
      },
      () => {
        this.getData();
        this.getETMFSchema();
      }
    );
  };

  clearFilter = (index) => () => {
    this.setState(
      (state) => {
        const filtersBy = cloneDeep(state.filtersBy);
        const filtersValue = cloneDeep(state.filtersValue);

        filtersBy.splice(index, 1);
        filtersValue.splice(index, 1);

        return { filtersBy, filtersValue, currentPage: 1 };
      },
      () => {
        this.getData();
        this.getETMFSchema();
      }
    );
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getData);
  };

  render() {
    const {
      isLoading,
      filtersBy,
      filtersValue,
      etmfSchema,
      etmfSchemaLimits,
      etmfSchemaFilter,
    } = this.state;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceDocumentsDashboard:Document Dashboard")}
            </h3>

            <div className={classes.actionWrapper}>
              <Button
                type="primary"
                onClick={() => {
                  this.setState({ missingDocumentsPerSiteShow: true });
                }}
              >
                Missing documents per site
              </Button>
              &nbsp; &nbsp;
              <Button
                type="primary"
                onClick={() => {
                  this.setState({ requiredStatusPerSiteShow: true });
                }}
              >
                Required documents per site status
              </Button>
              &nbsp; &nbsp;
              <Button
                type="primary"
                onClick={() => {
                  this.setState({ requiredStatusGeneralShow: true });
                }}
              >
                Central required document status
              </Button>
            </div>

            <div className={classes.filtersWrapper}>
              {filtersBy.map((_, index) => this.renderFilterItem({ index }))}

              {filtersBy.length === filtersValue.length &&
                filtersBy.length !== 5 &&
                this.renderFilterItem({})}
            </div>

            {isLoading && <Icon type="loading" />}
            {!isLoading && (
              <div>
                <Row gutter={12}>
                  <Col md={12}>
                    <h5 className="headline-default">{this.props.i18n.t("NamespaceDocumentsDashboard:Document inventory")}</h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("inventory"),
                        }}
                        width={100}
                        height={450}
                        options={chartOptions}
                      />
                    </div>

                    <div>
                      <LegendContainer legendData={this.state.inventory} i18n={this.props.i18n}/>
                    </div>
                  </Col>
                  <Col md={12}>
                    <h5 className="headline-default">
                      {this.props.i18n.t("NamespaceDocumentsDashboard:Document by visibility type")}
                    </h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("visibilityType"),
                        }}
                        width={100}
                        height={450}
                        options={chartOptions}
                      />
                    </div>

                    <div>
                      <LegendContainer legendData={this.state.visibilityType} i18n={this.props.i18n}/>
                    </div>
                  </Col>
                </Row>
                <br />
                <br />
                <br />
                <Row gutter={12}>
                  <Col md={12}>
                    <h5 className="headline-default">{this.props.i18n.t("NamespaceDocumentsDashboard:Document by sites")}</h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("documentsBySite"),
                        }}
                        width={100}
                        height={
                          get(this.state, "documentsBySite", []).length < 12
                            ? 450
                            : get(this.state, "documentsBySite", []).length * 42
                        }
                        options={chartOptions}
                      />
                    </div>

                    <div>
                      <LegendContainer
                        legendData={this.state.documentsBySite}
                        i18n={this.props.i18n}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <h5 className="headline-default">
                      {this.props.i18n.t("NamespaceDocumentsDashboard:Document by primary category")}
                    </h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("primaryCategory"),
                        }}
                        width={100}
                        height={450}
                        options={chartOptions}
                      />
                    </div>

                    <div>
                      <LegendContainer
                        legendData={this.state.primaryCategory}
                        i18n={this.props.i18n}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <br />
                <br />
                <Row gutter={12}>
                  <Col md={12}>
                    <h5 className="headline-default">{this.props.i18n.t("NamespaceDocumentsDashboard:Expiring documents")}</h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("documentsExpire"),
                        }}
                        width={100}
                        height={450}
                        options={chartOptions}
                      />
                    </div>

                    <div style={{ margin: "10px 0" }}>
                      <a
                        href={withParams(routes.admin.documentsEditor, {
                          filter_by: "expiry_year",
                          filter_value: moment().toISOString(),
                        })}
                        target="_blank"
                      >
                        <Button type="primary">{this.props.i18n.t("NamespaceDocumentsDashboard:Show expired documents")}</Button>
                      </a>
                    </div>

                    <div>
                      <LegendContainer
                        legendData={this.state.documentsExpire}
                        i18n={this.props.i18n}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <h5 className="headline-default">{this.props.i18n.t("NamespaceDocumentsDashboard:Missing documents")}</h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("missing"),
                        }}
                        width={100}
                        height={450}
                        options={chartOptions}
                      />
                    </div>

                    <div>
                      <LegendContainer legendData={this.state.missing}
                        i18n={this.props.i18n} />
                    </div>
                  </Col>
                </Row>
                <br />
                <br />
                <br />
                <Row gutter={12}>
                  <Col md={12}>
                    <h5 className="headline-default">
                      {this.props.i18n.t("NamespaceDocumentsDashboard:Central missing documents")}
                    </h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("missingGeneral"),
                        }}
                        width={100}
                        height={450}
                        options={chartOptions}
                      />
                    </div>

                    <div>
                      <LegendContainer legendData={this.state.missingGeneral}
                        i18n={this.props.i18n} />
                    </div>
                  </Col>
                  <Col md={12}>
                    <h5 className="headline-default">
                      {this.props.i18n.t("NamespaceDocumentsDashboard:Missing documents per site")}
                    </h5>
                    <div>
                      <HorizontalBar
                        data={{
                          labels: this.chartLabels(),
                          datasets: this.chartData("missingPerSite"),
                        }}
                        width={100}
                        height={
                          get(this.state, "missingPerSite", []).length < 12
                            ? 450
                            : get(this.state, "missingPerSite", []).length * 42
                        }
                        options={chartOptions}
                      />
                    </div>

                    <div>
                      <LegendContainer legendData={this.state.missingPerSite}
                        i18n={this.props.i18n} />
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Content>
        </Layout>

        <Modal
          width="90%"
          visible={this.state.missingDocumentsPerSiteShow}
          onCancel={() => {
            this.setState({ missingDocumentsPerSiteShow: false });
          }}
          footer={null}
        >
          {this.state.missingDocumentsPerSiteShow && (
            <MissingDocumentsPerSite />
          )}
        </Modal>

        <Modal
          width="90%"
          visible={this.state.requiredStatusPerSiteShow}
          onCancel={() => {
            this.setState({ requiredStatusPerSiteShow: false });
          }}
          footer={null}
        >
          {this.state.requiredStatusPerSiteShow && <RequiredStatusPerSite />}
        </Modal>
        <Modal
          width="90%"
          visible={this.state.requiredStatusGeneralShow}
          onCancel={() => {
            this.setState({ requiredStatusGeneralShow: false });
          }}
          footer={null}
        >
          {this.state.requiredStatusGeneralShow && <RequiredStatusGeneral />}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dimensionWidth: getDimensionWidth(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  documentGeneralReadPermission: getDocumentGeneralReadPermission(state),
  documentGeneralPrivateReadPermission: getDocumentGeneralPrivateReadPermission(
    state
  ),
  documentPerSiteReadPermission: getDocumentPerSiteReadPermission(state),
  documentPerSitePrivateReadPermission: getDocumentPerSitePrivateReadPermission(state),
  documentValidationReadPermission: getDocumentValidationReadPermission(state),
  documentPharmacyBinderPermission: getDocumentPharmacyBinderPermission(state),
  documentStudyRegulatoryBinderPermission: getDocumentStudyRegulatoryBinderPermission(
    state
  ),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentManagementDashboard))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentManagementDashboard/DocumentManagementDashboard.js